import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { ProductWithCurriculum } from 'types';
import {
  ClassroomLicenseUsage,
  StudentLicenseUsage,
  UserLicenseUsage
} from 'types/schema-generated-types';
import { getAssignedProducts, getDisplayName, getId } from 'utilities/product-utils';
import AppKey from 'assets/app-key.png';

const useStyles = makeStyles(theme => ({
  productsContainer: {
    display: 'flex'
  },
  productIconsContainer: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap'
  },
  productText: {
    paddingRight: 2
  },
  iconPadding: {
    paddingLeft: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5)
  }
}));

export interface ProductIconListProps
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  title?: string;
  licenseUsage?: ClassroomLicenseUsage[] | StudentLicenseUsage[] | UserLicenseUsage[] | null;
  products?: ProductWithCurriculum[];
  emptyMessage?: string;
}

const ProductIconList: React.FC<ProductIconListProps> = ({
  products: productsInput = [],
  licenseUsage,
  title,
  emptyMessage,
  ...rest
}) => {
  const classes = useStyles();
  const products = licenseUsage ? getAssignedProducts(licenseUsage) : productsInput;

  return (
    <div className={classes.productsContainer} {...rest}>
      {title && (
        <Typography component="span" variant="body1" className={classes.productText}>
          {title}:
        </Typography>
      )}
      {products.length === 0 && emptyMessage && (
        <Typography component="span" variant="body1">
          {emptyMessage}
        </Typography>
      )}
      <div className={classes.productIconsContainer}>
        {products.map(({ product, productCurriculum }) => (
          <img
            key={`icon_${getId(product, productCurriculum)}`}
            title={getDisplayName(product, productCurriculum)}
            alt={getDisplayName(product, productCurriculum)}
            className={classes.iconPadding}
            src={productCurriculum?.iconUrl ?? product?.iconUrl ?? AppKey}
            height="25"
          />
        ))}
      </div>
    </div>
  );
};

export default ProductIconList;
